// node modules
import React from 'react';
import { observer } from 'mobx-react';
// ui library
import { View, Text } from '@upstox/upstox-ui';
// modules
import FormatService from 'modules/Format';
import { useStore } from 'modules/Stores';
import { DATA_SETTINGS } from 'modules/OptionChain/consts';
// styles
import * as css from '../styles';
// components
import OptionChainCell from '../OptionChainCell/OptionChainCell';

const OptionChainOICell: React.FC<OptionChainTableCellProps> = ({
  instrumentKey,
  isCall,
}) => {
  const {
    tableSettings: {
      dataSettings: { changeIn },
    },
  } = useStore('OptionChainStore');

  const { getOptionParamValueWithInstrumentKey } = useStore('LiveDataStore');

  const openInterest = getOptionParamValueWithInstrumentKey(
    instrumentKey,
    'openInterest',
  );
  const previousOpenInterest = getOptionParamValueWithInstrumentKey(
    instrumentKey,
    'previousOpenInterest',
  );

  const calculatePercent = () => {
    if (
      !openInterest ||
      !previousOpenInterest ||
      openInterest === '0' ||
      previousOpenInterest === '0'
    ) {
      return '0';
    }

    const a = Number(openInterest);
    const b = Number(previousOpenInterest);
    return (100 * ((a - b) / b)).toFixed(2);
  };

  const percent = calculatePercent();

  const changeValue =
    !openInterest || !previousOpenInterest
      ? '--'
      : FormatService.formatToIndianFloat(
          (Number(openInterest) - Number(previousOpenInterest)) / 100000,
          2,
        );

  return (
    <OptionChainCell>
      <View flex justifyContent="center">
        <View cssProps={{ isCall }}>
          <Text
            color="text.1"
            variant="meta"
            size="m"
            lineHeight="l"
            css={css.optionChainCell}
          >
            {changeIn === DATA_SETTINGS.changePer
              ? `${FormatService.formatToIndianPrice(percent)}%`
              : changeValue}
          </Text>
        </View>
      </View>
    </OptionChainCell>
  );
};

export default observer(OptionChainOICell);
